module.exports = __webpack_public_path__ + "static/media/Manual_Maker_App_Push_Messaging.6739a739.png";